import { usePaymentStore } from '@/scopes/payment/infrastructure/usePaymentStore'
import { useVoucherStore } from '@/scopes/payment/infrastructure/vouchers/useVoucherStore'

export function useEffectivePaymentResult() {
  const paymentResult = usePaymentStore(state => state.paymentResult)
  const voucherApplyResult = useVoucherStore(state => state.screen === 'success' ? state.applyResult : null)

  return {
    effectivePaymentResult: voucherApplyResult ? 'ok' : paymentResult,
    voucherApplyResult,
  }
}
